import React, {Component} from "react";
import {TouchableOpacity, View, Text, Image, I18nManager, Dimensions, Alert} from "react-native";
import Colors from "../tools/Colors";
import HMTextView from "./HMTextView";
import {moderateScale} from "../tools/Scaling";
import {connect} from "react-redux";
import {Tools} from "../tools/Tools";
import HMIcon from "./HMIcon";
import {typeExport} from "../redux/store/type";
import HMLightbox from "./lightbox/HMLightbox";
import HMAlert from "./HMAlert";

const {width, height} = Dimensions.get("window");
let container = null;


class HMListItem2 extends Component {
    constructor(props) {
        super(props);
        container = this;

    }


    onMorePress() {
        HMAlert(
            'Boom',
            'This is an action call!',
            [{text: 'Aw yeah!'}]
        )
    }

    render() {

        const {styleRoot, file, text, textStyle, textType, style, type, borderRadius, height, NoShowIconOnpress, onPress, title, title2, image, props, onPressChild, path, video,typeIcon,styleTitle} = this.props;
        return (
            <View
                style={[styleRoot, {
                    width:'100%',

                    marginHorizontal: moderateScale(6),
                    marginVertical: moderateScale(2),
                    backgroundColor: Colors.white,
                    borderRadius: moderateScale(2),
                    //  marginHorizontal: moderateScale(6)
                }]}
                onPress={onPress}
            >
                <View style={{flex: 1, flexDirection: 'row', justifyContent: 'space-between'}}>

                    <View style={{flex: 1, flexDirection: 'row'}}>

                        <View
                            style={{
                                //flex: .14,
                                width: moderateScale(80),
                                height: '100%',
                                paddingVertical: moderateScale(2),
                                backgroundColor: Colors.colorSecondPrimary,
                                // height: moderateScale(28),
                                //  width: moderateScale(28),
                                justifyContent: 'center',
                                alignItems: 'center',
                                alignSelf: 'center',
                            }}>

                            <HMIcon name={image}
                                    type={typeIcon}
                                    style={{
                                        fontSize: moderateScale(20),
                                        color: Colors.light3,
                                        textAlign: "center",
                                        //    padding: moderateScale(4),

                                    }}/>
                            <HMTextView text={text}
                                        type={"bold"}
                                        style={{

                                            fontSize: moderateScale(10),
                                            color: Colors.white,
                                            //    textAlign: "center"
                                        }}
                                        styleRoot={{
                                            //  flexDirection: "row",
                                            flex: 1,
                                            //  width:'100%',
                                            //   justifyContent: "flex-end",
                                            flexWrap: 'wrap',

                                        }}
                            />
                        </View>
                        <View style={{width: moderateScale(14)}}/>

                        <View
                            style={{
                                paddingVertical: moderateScale(8),
                                flex: 1, flexDirection: 'row', alignItems: 'center', alignSelf: 'center'
                            }}>

                            {
                                file && title != null ?
                                    (<TouchableOpacity
                                        onPress={onPressChild}
                                        style={{width: typeExport.WIDTH, flexDirection: 'row'}}
                                    >
                                        {
                                            file == 'image' ?
                                                (
                                                    Platform.OS === "web" ?

                                                        <HMTextView
                                                            text={Tools.CheckValue(title) != null ? title : ' - '}
                                                            type={"bold"}
                                                            style={[{

                                                                fontSize: moderateScale(13),
                                                                color: Colors.colorPrimary,
                                                                //    textAlign: "center"
                                                            },styleTitle]}
                                                            styleRoot={{
                                                                //  flexDirection: "row",
                                                                flex: 1,
                                                                //  width:'100%',
                                                                //   justifyContent: "flex-end",
                                                                flexWrap: 'wrap',

                                                            }}
                                                        />
                                                        :
                                                        <HMLightbox uri={path} text={title}/>

                                                )
                                                :
                                                <HMTextView text={Tools.CheckValue(title) != null ? title : ' - '}
                                                            type={"bold"}
                                                            style={[{

                                                                fontSize: moderateScale(13),
                                                                color: Colors.colorPrimary,
                                                                //    textAlign: "center"
                                                            },styleTitle]}
                                                            styleRoot={{
                                                                //  flexDirection: "row",
                                                                flex: 1,
                                                                //  width:'100%',
                                                                //   justifyContent: "flex-end",
                                                                flexWrap: 'wrap',

                                                            }}

                                                />
                                        }
                                    </TouchableOpacity>)
                                    :
                                    (<HMTextView text={Tools.CheckValue(title) != null ? title : ' - '} type={"bold"}
                                                 style={[{

                                                     fontSize: moderateScale(13),
                                                     color: Colors.colorDark,
                                                     //    textAlign: "center"
                                                 },styleTitle]}
                                                 styleRoot={{
                                                     //  flexDirection: "row",
                                                     flex: 1,
                                                     //  width:'100%',
                                                     //   justifyContent: "flex-end",
                                                     flexWrap: 'wrap',

                                                 }}

                                    />)
                            }


                            {
                                title2 ?
                                    <HMTextView text={title2} type={"bold"}
                                                style={{

                                                    fontSize: moderateScale(14),
                                                    color: Colors.gray,
                                                    //textAlign: "center",
                                                    marginHorizontal: moderateScale(4)
                                                }}
                                                styleRoot={{
                                                    //  flexDirection: "row",
                                                    flex: 1,
                                                    //  width:'100%',
                                                    //   justifyContent: "flex-end",
                                                    flexWrap: 'wrap',

                                                }}

                                    />
                                    :
                                    null
                            }
                        </View>


                    </View>
                    <View style={{alignItems: 'center', justifyContent: 'center', paddingVertical: moderateScale(8)}}>
                        {
                            !NoShowIconOnpress ?
                                <TouchableOpacity
                                    style={{alignSelf: 'center'}}
                                    onPress={() => {
                                    }}
                                >
                                    <HMIcon name={I18nManager.getConstants().isRTL ? "ios-arrow-back" : 'ios-arrow-forward'}
                                            style={{
                                                fontSize: moderateScale(22),
                                                color: Colors.gray,
                                                textAlign: "center",
                                                padding: moderateScale(4),

                                            }}/>
                                </TouchableOpacity>
                                :
                                null
                        }

                    </View>
                </View>

                {/* <Modal
                    isVisible={this.state.visibleModal === 'selectVideo'}
                    backdropColor={Colors.gray}
                    backdropOpacity={0.8}
                    animationIn="zoomInDown"
                    animationOut="zoomOutUp"
                    animationInTiming={600}
                    animationOutTiming={600}
                    backdropTransitionInTiming={600}
                    backdropTransitionOutTiming={600}
                   // style={{height: '100%'}}
                    onBackdropPress={() => this.hiddenModal()}
                    onBackButtonPress={() => this.hiddenModal()}
                >*/}


                {/*   </Modal>*/}
                {/*
                <View style={{width: '100%', height: moderateScale(.7), backgroundColor: Colors.gray3}}/>
*/}
            </View>
        );
    }


}

const mapStateToProps = state => {
    return {
        // data: state.reducerSplashGetAllData,
        // NoInternetDialogSet: state.reducerMenuScreen.NoInternetDialogSet,
        // showLoadingSet: state.reducerMenuScreen.showLoadingSet,
        // resultsSetCommentScreen: state.reducerMenuScreen.resultsSetCommentScreen,
        // token: state.reducerSplashGetAllData.token,
        // DataSplashScreen: state.reducerSplashGetAllData,

    };
};
const mapDispatchToProps = dispatch => {
    return {}
};
export default connect(mapStateToProps, mapDispatchToProps)(HMListItem2);
